import React from 'react';

import PropTypes from 'prop-types';

import * as S from './styles';

export default function ModalFilter({ inputs, formatter }) {
  return (
    <S.Wrapper>
      {inputs.map(({ id, type, label, options, autocomplete }) => {
        return formatter(id, type, label, options, false, autocomplete)
      }
      )}
    </S.Wrapper>
  );
}

ModalFilter.propTypes = {
  inputs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      label: PropTypes.string,
      options: PropTypes.arrayOf(PropTypes.any),
    })
  ).isRequired,
  formatter: PropTypes.func.isRequired,
};
